export default __webpack_public_path__ + "static/media/ridgegourd.61b347f4.png";